import { fetchEmailTemplates } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IEmailTemplate } from '../../../api/base/EmailTemplates/types';
import { RemoveTemplateType, UpdateTemplateType } from './types';

export type IEmailTemplateState = IListState<IEmailTemplate>;

const initialState: IEmailTemplateState = { ...initialListState };

const emailTemplatesSlice = getListSlice({
  moduleName: 'emailTemplates',
  fetchDataThunk: fetchEmailTemplates,
  reducers: {
    updateEmailTemplate(state, action: UpdateTemplateType) {
      const index = state.data.findIndex(
        (item) => item.id === action.payload.id,
      );
      if (index) {
        state.data[index] = action.payload;
      }
    },
    deleteEmailTemplate(state, action: RemoveTemplateType) {
      const index = state.data.findIndex((item) => item.id === action.payload);
      state.data.splice(index, 1);
    },
    setEmailTemplates(state, action) {
      state.data = action.payload;
    },
    addEmailTemplate(state, action) {
      state.data.push(action.payload);
    },
  },
  initialState,
});

export const {
  updateEmailTemplate,
  deleteEmailTemplate,
  setEmailTemplates,
  addEmailTemplate,
} = emailTemplatesSlice.actions;

export const emailTemplatesReducer = emailTemplatesSlice.reducer;
